import {useEffect} from 'react';

const PDP_KIND_CLASSES = ['product-view--simple', 'product-view--complex'];

/**
 * Adds `product-view--simple` or `product-view--complex` to `#app-main` while PDP is mounted.
 */
export const useAppMainPdpKind = (isComplexProduct) => {
  useEffect(() => {
    const mainEl = document.getElementById('app-main');

    if (!mainEl) return;

    const kindClass = isComplexProduct ? 'product-view--complex' : 'product-view--simple';

    mainEl.classList.remove(...PDP_KIND_CLASSES);
    mainEl.classList.add(kindClass);

    return () => {
      mainEl.classList.remove(...PDP_KIND_CLASSES);
    };
  }, [isComplexProduct]);
};
